import { generatePath } from 'react-router-dom';
import SettingsListItem from 'flow/components/custom-components/SettingsListItem';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectIsAdmin } from 'flow/selectors/own-extension-selectors';
import { ChannelKey, QueueKey, ReferKey } from 'flow/types/EntityKeys';
import { ActiveProfile as ActiveProfileType } from 'flow/types/Profile';
import { RouteKey, routes } from 'flow/types/routes';
import { TypedMap } from 'flow/types/TypedMap';
import { getActiveUntil } from 'flow/utils';
import PbxMenuIcon from './PbxMenuIcon';

interface Props {
    entityKey: ChannelKey | QueueKey | ReferKey;
    isEditable: boolean;
    routeKey: RouteKey;
    activeProfile?: TypedMap<ActiveProfileType>;
}

const ActiveProfile = ({
    entityKey,
    isEditable,
    routeKey,
    activeProfile,
}: Props) => {
    const { i18next } = useAppContext();

    const ownExtensionIsAdmin = useAppSelector(selectIsAdmin);

    return (
        <SettingsListItem
            editable={ownExtensionIsAdmin || isEditable}
            to={generatePath(routes[routeKey], {
                entityKey,
            })}
            className="py-2"
        >
            <PbxMenuIcon iconKey="accessTime" />

            {activeProfile
                ? `${activeProfile.get('description')} ${getActiveUntil(
                      activeProfile,
                      i18next,
                  )}`
                : i18next.t('pbx.pbxmode')}
        </SettingsListItem>
    );
};

export default ActiveProfile;
